// dashboard

// Users
import UserListView from "pages/Users/ListView";
import UserSegment from "pages/Users/UserSegment";
import UserGridView from "pages/Users/GridView";

// auth

// Reset Password

import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";

import UserProfile from "pages/Authentication/UserProfile";
import Account from "pages/Pages/Account";
import Skills from "pages/skills/Skills";
import Roles from "pages/roles/Roles";
import ServiceCategory from "pages/serviceCategory/ServiceCategory";
import JobPlans from "pages/jobPlans/JobPlans";
import SubscriptionPlans from "pages/subscriptionPlans";
import Notifications from "pages/notifications";
import Bookings from "pages/bookings";
import SendInvoice from "pages/send-invoice";
import ServicePlns from "pages/servicePlans";
import Dashboard from "pages/Pages/dashboard";
import ActivityLogs from "pages/activities";
import EmailLogs from "pages/emailLogs";
import ProductEvents from "pages/productEvents";
import ApiActivityLogs from "pages/apiActivityLogs";
import Jobs from "pages/jobs";
import JobDetails from "pages/jobDetails/_components/jobDetails";
import CreateJob from "pages/post-jobs/page";
import EditJob from "pages/editJob";
import ArchivedUsers from "pages/Users/ArhivedUsers";
import Transactions from "pages/transactions";
import Settings from "pages/settings";
import Blogs from "pages/blogs/Blog";
import InvoiceDetails from "pages/invoice";
import Events from "pages/events";
import VerificationOrders from "pages/verificationOrders";
import CsrTickets from "pages/csr";
import LabTestOrders from "pages/labTestOrders";
import Complaints from "pages/complaints";
import Conversations from "pages/conversations";
import Placements from "pages/placements";
import Laboratories from "pages/laboratories";
import Employers from "pages/employers";
import Agencies from "pages/agencies";
import Wallets from "pages/wallets";
import Inspections from "pages/inspections";
import Myndas from "pages/myndas";
import Guarantors from "pages/guarantors";
import VerificationServices from "pages/verificationServices";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: "/dashboard", component: Dashboard },
  // Users
  { path: "/apps-users-list", component: UserListView },
  // Each dashboard card opens its own page rather than filtering the list
  // in place, so a group can be linked to, reloaded and backed out of.
  { path: "/apps-users-list/:segment", component: UserSegment },
  { path: "/archived-users", component: ArchivedUsers },
  { path: "/transactions", component: Transactions },
  { path: "/skills", component: Skills },
  { path: "/roles", component: Roles },
  { path: "/service-category", component: ServiceCategory },
  { path: "/job-plans", component: JobPlans },
  { path: "/subscription-plans", component: SubscriptionPlans },
  { path: "/notifications", component: Notifications },
  { path: "/bookings", component: Bookings },
  { path: "/send-invoice", component: SendInvoice },
  { path: "/service-plans", component: ServicePlns },
  { path: "/invoice", component: InvoiceDetails },
  { path: "/events", component: Events },
  { path: "/activities", component: ActivityLogs },
  { path: "/email-logs", component: EmailLogs },
  { path: "/user-activity", component: ProductEvents },
  { path: "/api-activity-logs", component: ApiActivityLogs },
  { path: "/jobs", component: Jobs },
  { path: "/job-details", component: JobDetails },
  { path: "/create-job", component: CreateJob },
  { path: "/edit-job", component: EditJob },
  { path: "/settings", component: Settings },
  { path: "/blogs", component: Blogs },
  { path: "/verification-orders", component: VerificationOrders },
  { path: "/csr", component: CsrTickets },
  { path: "/lab-test-orders", component: LabTestOrders },
  { path: "/complaints", component: Complaints },
  { path: "/conversations", component: Conversations },
  { path: "/placements", component: Placements },
  { path: "/laboratories", component: Laboratories },
  { path: "/employers", component: Employers },
  { path: "/agencies", component: Agencies },
  { path: "/wallets", component: Wallets },
  { path: "/inspections", component: Inspections },
  { path: "/myndas", component: Myndas },
  { path: "/guarantors", component: Guarantors },
  { path: "/verification-services", component: VerificationServices },

  // pages
  { path: "/pages-account/:id", component: Account },

  // profile
  { path: "/user-profile", component: UserProfile },
];

const publicRoutes = [
  ,
  // Landing

  // auth

  // logout

  // authentication
  { path: "/", component: Login },
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
];

export { authProtectedRoutes, publicRoutes };
